import axios from 'axios'
import store from '@/store/index'
import { errorMsgHandle } from '@/utils/errorMsgUtil'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  // if (store.state.token) {
  //   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改 改了Authorization，格式是Authorization：Token xxxxx
  //   config.headers['Authorization'] = 'Token ' + store.state.token
  //   // config.headers['plat-id'] = '224fb9cdcea33e74824ecc0352ff23f3'
  // }
  config.headers['IsDapin'] = '1'
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    return response
  },
  error => {
     if (error.response && error.response.status === 403) {

     }
  }
  // response => {
  //   const res = response.data
  //   if (res.code !== 20000) {
  //     Message({
  //       message: res.message,
  //       type: 'error',
  //       duration: 5 * 1000
  //     })
  //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       // 请自行在引入 MessageBox
  //       // import { Message, MessageBox } from 'element-ui'
  //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload() // 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response.data
  //   }
  // },
  // error => {
  //   console.log('err' + error) // for debug
  //   if (error.response.status === 401) {
  //     store.commit('SET_TOKEN', '')
  //     removeToken()
  //     console.log('捕捉到401状态码的错误')
  //     router.push({ path: '/401' })
  //   } else if (error.response.status === 404) {
  //     console.log('捕捉到404状态码的错误', error.response.data.message)
  //     // router.push({ path: '/404' })
  //   } else if (error.response.status === 500) {
  //     console.log('捕捉到500状态码的错误')
  //     router.push({ path: '/500' })
  //   }
  //   Message({
  //     message: error.response.data.message,
  //     type: 'error',
  //     duration: 5 * 1000
  //   })
  //   return Promise.reject(error)
  // })
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js